import React, { Component } from 'react';
import { connect } from 'react-redux'; // to connect to redux store from containers redux.js or any other redux store
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import PropTypes from 'prop-types'; // to validate and set default props  coming to this component
import { closeVideo } from 'components/Banner/Banner.actions';
import { bannerSelector } from 'components/Banner/Banner.redux';
import styles from './FullScreenVideo.scss';// to import local scss fle

class FullScreenVideo extends Component {
  static propTypes = {
    closeVideo: PropTypes.func.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {

    };
    this.toggleVideo = this.toggleVideo.bind(this);
  }
  toggleVideo() {
    this.props.closeVideo();
  }
  render() {
    return (
      <div className={cn('row', styles.videoContainer)}>
        <video autoPlay controls>
          <source src="https://media.dev.myrecruitboard.com/Images/bigVideo.mp4" type="video/mp4" />
        </video>
        <button onClick={this.toggleVideo} className={styles.closeButton} >X</button>
      </div>
    );
  }
}

export default connect(bannerSelector, {
  closeVideo,
})(FullScreenVideo);




// WEBPACK FOOTER //
// ./src/components/FullScreenVideo/FullScreenVideo.js